import { c as _c } from "react/compiler-runtime";
import Container from "../wrapper/Container";
import SectionSubHeading from "../common/titles/SectionSubHeading";
import SectionTitle from "../common/titles/SectionTitle";
import ContactForm from "@/components/global/ContactForm";
const Contact = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-6"><div className="space-y-2"><SectionSubHeading subtitle="Reach us anytime" /><SectionTitle title="Contact" className="font-black" /></div><p className="text-muted-foreground text-lg lg:max-w-100">Our mission is to empower designers, developers and agencies with the tools they need to build their digital products more efficiently.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-1.5"><span className="text-xs font-bold text-muted-foreground uppercase tracking-wider">Email</span><span className="font-bold text-lg md:text-xl text-foreground">hi@octarnal.com</span></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col justify-between h-full">{t0}<div className="lg:flex-row flex-col lg:items-center gap-6 lg:gap-12 mt-16 md:mt-10 lg:mt-0 pb-1 hidden md:flex">{t1}<div className="flex flex-col gap-1.5"><span className="text-xs font-bold text-muted-foreground uppercase tracking-wider">Tel</span><span className="font-bold text-lg md:text-xl text-foreground">+880-185-202-4152</span></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col justify-end"><ContactForm /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col gap-1.5"><span className="text-xs font-bold text-muted-foreground uppercase tracking-wider">Email</span><span className="font-bold text-lg md:text-xl text-foreground">hi@octarnal.com</span></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Container className="grid md:grid-cols-2 grid-cols-1 px-4 lg:px-10 gap-8 md:gap-24 py-16 md:py-20">{t2}{t3}<div className="flex-col gap-6 mt-1 pb-1 flex md:hidden">{t4}<div className="flex flex-col gap-1.5"><span className="text-xs font-bold text-muted-foreground uppercase tracking-wider">Tel</span><span className="font-bold text-lg md:text-xl text-foreground">+880-185-202-4152</span></div></div></Container>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default Contact;